var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Flex from "@irati/ui/src/Flex";
export var StyledFlex = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", ";\n"], ["\n  background-color: ", ";\n  border-radius: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return "" + theme.colors.secondary2_50;
}, function (_a) {
    var theme = _a.theme;
    return "" + theme.border.radius;
});
var templateObject_1;
